import {h, Fragment} from "preact"
import { useAppStateSelector, pick } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'
import CollectionLayout from './CollectionLayout'
import Filters from './Filters'

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppStateSelector((state) =>
        pick(state, 'loading', 'query', 'response', 'pageType')
    )
    const [collectionType, setCollectionType] = useState('default')
    const [isMobile, setIsMobile] = useState(false)

    const docCount = response.products?.total ?? 0

    useEffect(() => {
        setIsMobile(window.innerWidth < 768)
    }, [])

    useEffect(() => {
        // Check if there's an image-with-text component with "The Artist" paragraph
        const imageWithTextElements = document.querySelectorAll('image-with-text')
        let isArtistCollection = false

        for (const element of imageWithTextElements) {
            const paragraphs = element.querySelectorAll('p')
            for (const paragraph of paragraphs) {
                if (paragraph.textContent.trim() === 'The Artist') {
                    isArtistCollection = true
                    break
                }
            }
            if (isArtistCollection) break
        }

        if (isArtistCollection) {
            setCollectionType('artistCollection')
        } else {
            setCollectionType('default')
        }
    }, [])

    function getHeightObserverStyle(collectionType, isMobile) {
        if (collectionType === 'artistCollection' && isMobile) {
            return { minHeight: 0 }
        }
        return {}
    }

    return (
        <height-observer
            variable='collection-toolbar'
            class='collection-toolbar full-bleed'
            // style={getHeightObserverStyle(collectionType, isMobile)}
        >
            {/* Rendering logic based on collectionType and isMobile */}
            {(collectionType === 'default' || isMobile) && (
                <>
                    <Filters />
                    {!isMobile && <ArtworkCount count={docCount} isMobile={isMobile} />}
                    <CollectionLayout defaultDesktopLayout='medium' />
                </>
            )}
            {collectionType === 'artistCollection' && !isMobile && (
                <>
                    <Filters />
                    <ArtworkCount count={docCount} isMobile={isMobile} />
                    <CollectionLayout defaultDesktopLayout='large' />
                </>
            )}
        </height-observer>
    )
}

function ArtworkCount({ count, isMobile }) {
    return (
        <>
            {isMobile ? (
                <p class='collection-toolbar__products-count h6 text-subdued' style='padding-inline: 1.25rem;'>
                    {count} Artworks
                </p>
            ) : (
                <p class='collection-toolbar__products-count h6 text-subdued md-max:hidden'>{count} Artworks</p>
            )}
        </>
    )
}
